import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDBytBwzOUfnRcmVQgxh3VOonmhFFdf2nA",
  authDomain: "rockettrail-2705c.firebaseapp.com",
  projectId: "rockettrail-2705c",
  storageBucket: "rockettrail-2705c.firebasestorage.app",
  messagingSenderId: "68227689110",
  appId: "1:68227689110:web:b3714d585e155503a0f0b7",
  measurementId: "G-H2VPB359HB"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, 'us-central1');

export { auth, db, functions, app };
